/**
 * @generated SignedSource<<69b97d63b5b98f5648dccf73e9f8a209>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerItems_question$data = {
  readonly answers: ReadonlyArray<{
    readonly author: {
      readonly sellerPreferences: {
        readonly label: string | null;
        readonly storefrontUrl: string | null;
      } | null;
      readonly vertical: string | null;
    } | null;
  } | null> | null;
  readonly sellerItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly serviceId: string | null;
          readonly title: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ItemTile_item">;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "SellerItems_question";
};
export type SellerItems_question$key = {
  readonly " $data"?: SellerItems_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerItems_question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerItems_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerType",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vertical",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SellerPreferences",
              "kind": "LinkedField",
              "name": "sellerPreferences",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "storefrontUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerItemsConnection",
      "kind": "LinkedField",
      "name": "sellerItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSearchResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ItemTile_item"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionType",
  "abstractKey": null
};

(node as any).hash = "a716414b5665d1616cdeeba5c8c55364";

export default node;
